import React from "react";

export default function UploadInfo() {
  return (
    <>
      <div className="upload-wrapper">
        <i className="fad fa-spinner me-2"></i>
        <span>Uploading</span>
      </div>
    </>
  );
}
